import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, urlBackend } from "@/shared";
import {  UnidadTransporte, UnidadTransporteParams } from "@/shared/interfaces";
import { useQuery } from "@tanstack/react-query";

const { get} = erpApi();

export const useFetchUnidadTransporte = (params?: UnidadTransporteParams) => {
  return useQuery({
    queryKey: ['unidad-transporte', ...Object.values(params || {})],
    queryFn: async () => {
      return await getUnidadTransporte(params);
    },
  });
};

export const getUnidadTransporte = async (params?: UnidadTransporteParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<UnidadTransporte>(
    `${urlBackend}api/v1/unidadtransporte/?${queryParams}`,
    true
  );

  return resp;
};